var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('navigation-pane',_vm._l((_vm.buttons),function(button,index){return _c('external-menu-button',{key:index,attrs:{"button":button}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }